<template>
	<div>
		<div v-show="Gzhz_gzzb">
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">OA审批-{{organize_name}}</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px;overflow-x: hidden">
				<el-row style="">
					<el-row>
						<el-table :header-cell-style="{ background: '#d3eae2', color: '#000000' }" :border="true"
							:row-class-name="tableRowClassName" ref="table" :data="gzzbList" show-summary height="650"
							tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChange"
							:expand-row-keys="expands" @expand-change="handleSelect" >
							
							<el-table-column type="expand">
								<template slot-scope="scope">
									<el-table
										:header-cell-style="{ background: '#edeff1', color: '#000000' }"
										:border="true" ref="table" :data="childTable" height="400"
										tooltip-effect="dark" style="width: 100%;"
										@selection-change="handleSelectionChanges" @select="handleSelects">
										<el-table-column align="center" label="序号" width="50">
											<template
												slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
										</el-table-column>
										<el-table-column prop="organize_name" align="center" label="支援项目名">
										</el-table-column>
										<el-table-column prop="number_of_investors" align="center"
											label="开资人数"></el-table-column>
										<el-table-column prop="payroll_payable" align="center"
											label="工资表应发工资"></el-table-column>
										<el-table-column prop="payroll_actual_salary" align="center"
											label="工资表实发工资"></el-table-column>
									</el-table>
								</template>
							</el-table-column>

							<el-table-column type="selection" width="55">
							</el-table-column>
							<el-table-column align="center" label="序号" width="55">
								<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
							</el-table-column>
							<el-table-column prop="organize_name" align="center" label="项目名称" width="200">
							</el-table-column>
							<el-table-column align="center" label="收入">
								
								<el-table-column prop="actual_estimate_name" align="center" label="是否开票" width="120"></el-table-column>
								<el-table-column prop="invoiced_amount" align="center" label="开发票金额" width="120"></el-table-column>
								<el-table-column align="center" label="开票明细" width="100">
									<el-table-column prop="wage_quota" align="center" label="工资定额" width="100"></el-table-column>
									<el-table-column prop="contract_amount" align="center" label="合同金额" width="100"></el-table-column>
									<el-table-column prop="quota_proportion" align="center" label="定额占比" width="100"></el-table-column>
								</el-table-column>
							</el-table-column>
							<el-table-column align="center" label="工资明细">
								<el-table-column prop="invoicing_shift" align="center" label="开发票班次" width="120"></el-table-column>
								<el-table-column prop="quota_difference" align="center" label="定额差额" width="120"></el-table-column>
								<el-table-column prop="number_of_investors" align="center" label="开资人数" width="80"></el-table-column>
								<el-table-column prop="payroll_payable" align="center" label="工资表应发工资" width="120"></el-table-column>
								<el-table-column prop="personal_part_of_social_security" align="center" label="社保个人部分" width="120"></el-table-column>
								<el-table-column prop="accumulation_fund_deduction" align="center" label="公积金扣款" width="120"></el-table-column>
								<el-table-column prop="accident_insurance_deduction" align="center" label="意外保险扣款" width="120"></el-table-column>
								<el-table-column prop="clothing_deposit" align="center" label="服装押金" width="100"></el-table-column>
								<el-table-column prop="payroll_actual_salary" align="center" label="工资表实发工资" width="120"></el-table-column>
								<el-table-column prop="temporary_expenses" align="center" label="临勤费用" width="120"></el-table-column>
								<el-table-column prop="total_expenses" align="center" label="总费用" width="120"></el-table-column>
								<el-table-column prop="actual_delivery_shift" align="center" label="实发班次" width="120"></el-table-column>
							</el-table-column>
							<el-table-column align="center" label="工资占比">
								<el-table-column prop="proportion_wages" align="center" label="本月工资占比" width="80">
									<template slot-scope="scope">
										<span>{{ scope.row.proportion_wages }}%</span>
									</template>
								</el-table-column>
								<el-table-column prop="previous_month_one" align="center" label="上月工资占比" width="80">
									<template slot-scope="scope">
										<span>{{ scope.row.previous_month_one }}%</span>
									</template>
								</el-table-column>
							</el-table-column>
							<el-table-column align="center" label="备注" width="160">
								<template slot-scope="scope">
									<el-input v-show="scope.row.show" v-model="scope.row.remarks"
										size="mini" style="margin-left:-5px; width: 150px;"></el-input>
									<span v-show="!scope.row.show">{{ scope.row.remarks }}</span>
								</template>
							</el-table-column>



							<!-- <el-table-column align="center" label="状态" width="160">
								<template slot-scope="scope">
									<img src="../../../assets/待审批.png" v-show="scope.row.spare5 === '0'" />
									<img src="../../../assets/已同意.png" v-show="scope.row.spare5 === '1'" />
								</template>
							</el-table-column> -->
							<el-table-column align="center" label="操作" width="80">
								<template slot-scope="scope">
									<span style="color:#01714d;" @click="goMingXi(scope.row)">详情</span>
								</template>
							</el-table-column>
						</el-table>
					</el-row>
					<el-row style="display: flex; justify-content: flex-start;flex-wrap: wrap;margin: 0 20px;">
						<div v-for="(item,index) in inforchild" style="flex:1; width: calc((100% - 20px) / 6);min-width: calc((100% - 20px) / 6);max-width: calc((100% - 20px) / 6);">
							<div style="margin:20px 0 0 0 ;font-size:18px;">{{item.role_name}} : {{item.staff_name}}</div>
						</div>
					</el-row>
				</el-row>
				
			</div>

		</div>
		<gzmx v-show="gzmx" ref="gzmx" :gzmxList="gzmxList" :zygzmxList="zygzmxList" :inforchilds="inforchilds" :organize_name="organize_name"></gzmx>
	</div>
</template>

<script>
	import axios from "axios";
	import gzmx from "./Gzhz_gzmx.vue";
	export default {
		components: {
			gzmx: gzmx,
		},
		props: ["gzzbList","inforchild","Asp_gzhz","organize_name"],
		data() {
			return {
				childTable:[],
				organize_name:"",
				gzzbList: {},
				inforchilds:{},
				gzmxList: [],
				zygzmxList:[],
				Gzhz_gzzb:true,
				gzmx: false,
			};
		},
		methods: {
			handleSelect(row, expandedRows){
				axios.get(this.$globals.http + 'Regional/getSupportProportionTable', {
					params: {
						info: row.id
					}
				}).then(res => {
					this.childTable = res.data.data;
				}).catch(err => {
					console.log(err)
				})
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						alert('submit!');
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			async goMingXi(e) {
				this.organize_name = e.organize_name;
				axios.get(this.$globals.http + 'examineDetails/getExamineUserFive', {
					params: {
						organizeId: e.id
					}
				}).then(res => {
					this.inforchilds = res.data.data;
				}).catch(err => {
					console.log(err)
				});
				axios.get(this.$globals.http + 'examine/selectSalaryDetailsList', {
					params: {
						id: e.id
					}
				}).then(res => {
					this.gzmxList = res.data.data.detailed;
					this.zygzmxList = res.data.data.detaileds;
					this.Gzhz_gzzb = false;
					this.gzmx = true;
				}).catch(err => {
					console.log(err)
				})
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			Return() {
				this.$parent.close();
			},
			close(){
				this.gzmx = false;
				this.Gzhz_gzzb = true;
			}
		}
	}
</script>

<style>
	.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
		content: '';
	}
</style>



// WEBPACK FOOTER //
// Gzhz_gzzb.vue?2b2a3fc1